import React from "react";
import { Router, Switch } from "react-router-dom";
import RouteComponent from "./route-config.jsx";
import { UrlCollection } from "./common/url-collection";
import history from "./common/history";

//--- Loading
import AppLoading from "./components/loading/loading.view";

//--- Layout
import LayoutView from "./components/layout/layout.view";
import LayoutUserView from "./components/layout/layout-user.view.jsx";
import LayoutDetail from "./components/layout/layout-detail.view";

//--- Home
import Dashboard from "./modules/dashboard/dashboard.view.jsx";
//--- Admin
import Login from "./modules/login/login.view.jsx";
import ForgotPassword from "./modules/forgot-password/forgot-password.view.jsx";
import ResetPassword from "./modules/reset-password/reset-password.view.jsx";

//--- Consult the community
import EmailTemplate from "./modules/email-template/email-template";
import RoleManagement from "./modules/role-management/role-management";
import ContactManagement from "./modules/contact-management/contact-management.view";
import EmailGenerated from "./modules/email-generated/email-generated.view";
import UserManagement from "./modules/user-management/user-management.view";
import CommuneManagement from "./modules/communce-management/communce-management.view";
import ProviceManagement from "./modules/province-management/provice-management.view";
import DistrictManagement from "./modules/district-management/district-management.view";
import UserLogHistory from "./modules/user-log/user-log-history.view";
import LandTypeManagement from "./modules/land-type-management/land-type-management.view";
import LandTypeDetailManagement from "./modules/land-type-detail-management/land-type-detail-management.view";
//---Log
import Log from "./modules/log/log.jsx";

//--- Slider
import Slider from "./modules/slider/slider.view.jsx";

//--- News
import News from "./modules/news/news.view.jsx";

//--- Map
import MapData from "./modules/map-data/map-data.view.jsx";
import InitMapDataView from "./modules/init-map-data/init-map-data";

//--- Records management
import RecordsManagement from "./modules/planning-announcement-process/records-management/records-management.view.jsx";
import AddRecordsManagement from "./modules/planning-announcement-process/records-management/add-records-management/add-records-management.view";
import EditRecordsManagement from "./modules/planning-announcement-process/records-management/edit-records-management/edit-records-management.view";
import EditAnnouce from "./modules/planning-announcement-process/announced/edit-announced/edit-announced.view";
import PlanningRelate from "./modules/planning-announcement-process/planning-related/planning-related.view";
import PlanningRelatedPage from "./modules/planning-announcement-process/planning-related/planning-related-page.view.jsx";
import DocumentSetting from "./modules/planning-announcement-process/document-settings/document-settings.view";
import DocumentSettingsPage from "./modules/planning-announcement-process/document-settings/document.view";
import ConsultTheCommunity from "./modules/planning-announcement-process/consult-the-community/consult-the-community.view";
import ConsultTheCommunityPage from "./modules/planning-announcement-process/consult-the-community/consult-the-community-page.view";
import LinkMapProcess from "./modules/planning-announcement-process/link-map/link-map.view";
import Investor from "./modules/investor/investor.view";
import ApprovalAgency from "./modules/approval-agency/approval-agency.view";
import ProjectManagement from "./modules/project-management/project-management.view";
import MapProjectManagement from "./modules/project-management/map-project-management.view";
//--- Link
import LinkGroupManagementView from "./modules/link-group/link-group-management.view.jsx";
import ServiceLinkManagementView from "./modules/service-links/service-link-management.view";

//--- Opinion form
import OpinionForm from "./modules/opinion-form/opinion-form.view.jsx";

//--- Table Layer Structure
import TableStructure from "./modules/table-structure/table-structure.view.jsx";

//--- Access denied
import AccessDenied from "./modules/access-denied/access-denied.view.jsx";

import DocumentManagement from "./modules/document-management/document-management.view.jsx";
import MyAccount from "./modules/my-account/my-account.view.jsx";
import PlanningUnit from "./modules/planning-unit/planning-unit.view.jsx";
import { QHDT } from "./modules/qhdt/qhdt.view.jsx";
import { PTQD } from "./modules/ptqd/ptqd.view.jsx";
import DialogWarningExpired from "./components/dialog-warning-expired/dialog-warning-expired.view";
import LockScreen from "./components/lock-screen/lock-screen.view.jsx";
import ListProject from "./modules/project-management/list-project/list-project.view.jsx";
import LisenceFile from "./modules/lisence-file/lisence-file.view.jsx";
// Lisence File
import AddLisenceFile from "./modules/lisence-file/add-lisence-file/add-lisence-file.view";
import MapLisenceFile from "./modules/lisence-file/map-lisence-file/map-lisence-file.view.jsx";
function App() {
  return (
    <div>
      <DialogWarningExpired />
      <Router history={history}>
        <AppLoading />
        <LockScreen />
        <Switch>
          <RouteComponent
            exact
            layout={LayoutUserView}
            component={Login}
            path={UrlCollection.Login}
            isSetActive={false}
          />
          <RouteComponent
            exact
            layout={LayoutUserView}
            component={ForgotPassword}
            path={UrlCollection.ForgotPassword}
            isSetActive={false}
          />
          <RouteComponent
            exact
            layout={LayoutUserView}
            component={ResetPassword}
            path={UrlCollection.ResetPassword}
            isSetActive={false}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Dashboard">
                <Dashboard />
              </LayoutView>
            )}
            component={Dashboard}
            path={UrlCollection.Dashboard}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Dashboard">
                <Dashboard />
              </LayoutView>
            )}
            component={Dashboard}
            path={UrlCollection.Home}
          />
          <RouteComponent
            exact
            layout={QHDT}
            component={QHDT}
            path={UrlCollection.QHDT}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Danh sách dự án đầu tư xây dựng">
                <ProjectManagement />
              </LayoutView>
            )}
            path={UrlCollection.ProjectManagement}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Bản đồ dự án đầu tư ">
                <MapProjectManagement />
              </LayoutView>
            )}
            path={UrlCollection.MapProjectManagement}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Phân tích quyết định">
                <PTQD />
              </LayoutView>
            )}
            component={PTQD}
            path={UrlCollection.PTQD}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Nội dung QH hạ tầng kỹ thuật">
                <RecordsManagement isQHHTKT />
              </LayoutView>
            )}
            path={UrlCollection.QH_HTKT}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Thêm nội dung QH hạ tầng kĩ thuật">
                <AddRecordsManagement isQHHTKT />
              </LayoutView>
            )}
            path={UrlCollection.Add_QH_HTKT}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Chỉnh sửa nội dung QH hạ tầng kĩ thuật">
                <EditRecordsManagement isQHHTKT />
              </LayoutView>
            )}
            path={UrlCollection.Edit_QH_HTKT}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Link bản đồ">
                <LinkMapProcess isQHHTKT />
              </LayoutView>
            )}
            path={UrlCollection.QH_HTKT_LINK_MAP}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Xin ý kiến">
                <ConsultTheCommunity isQHHTKT />
              </LayoutView>
            )}
            path={UrlCollection.QH_HTKT_CONSULT}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutDetail title="Xin ý kiến">
                <ConsultTheCommunityPage isQHHTKT />
              </LayoutDetail>
            )}
            path={UrlCollection.QH_HTKT_CONSULT_ID}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Thiết lập hồ sơ">
                <DocumentSetting isQHHTKT />
              </LayoutView>
            )}
            path={UrlCollection.QH_HTKT_SETUP_DOCUMENT}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutDetail title="Thiết lập hồ sơ">
                <DocumentSettingsPage isQHHTKT />
              </LayoutDetail>
            )}
            path={UrlCollection.QH_HTKT_SETUP_DOCUMENT_DETAIL}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quy hoạch liên quan">
                <PlanningRelate isQHHTKT />
              </LayoutView>
            )}
            path={UrlCollection.QH_HTKT_Relate}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutDetail title="Quy hoạch liên quan">
                <PlanningRelatedPage isQHHTKT />
              </LayoutDetail>
            )}
            path={UrlCollection.QH_HTKT_RelateId}
          />
          {/* Dashboard */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Dashboard">
                <Dashboard />
              </LayoutView>
            )}
            path={UrlCollection.Dashboard}
          />

          {/* quy hoạch các cấp */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quy hoạch các cấp">
                <RecordsManagement isQHCC />
              </LayoutView>
            )}
            path={UrlCollection.PlanningCC}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Thêm dự án quy hoạch các cấp">
                <AddRecordsManagement isQHCC />
              </LayoutView>
            )}
            path={UrlCollection.AddPlanningCC}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Chỉnh sửa dự án quy hoạch các cấp">
                <EditRecordsManagement isQHCC />
              </LayoutView>
            )}
            path={UrlCollection.EditPlanningCC}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Link bản đồ">
                <LinkMapProcess isQHCC />
              </LayoutView>
            )}
            path={UrlCollection.LinkMapPlanningCC}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Xin ý kiến">
                <ConsultTheCommunity isQHCC />
              </LayoutView>
            )}
            path={UrlCollection.ConsultPlanningCC}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutDetail title="Xin ý kiến">
                <ConsultTheCommunityPage isQHCC />
              </LayoutDetail>
            )}
            path={UrlCollection.ConsultPlanningCCId}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Thiết lập hồ sơ">
                <DocumentSetting isQHCC />
              </LayoutView>
            )}
            path={UrlCollection.DocumentPlanningCC}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutDetail title="Thiết lập hồ sơ">
                <DocumentSettingsPage isQHCC />
              </LayoutDetail>
            )}
            path={UrlCollection.DocumentPlanningCCId}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quy hoạch liên quan">
                <PlanningRelate isQHCC />
              </LayoutView>
            )}
            path={UrlCollection.PlanningCCRelate}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutDetail title="Quy hoạch liên quan">
                <PlanningRelatedPage isQHCC />
              </LayoutDetail>
            )}
            path={UrlCollection.PlanningCCRelateId}
          />
          {/* quy hoạch khác */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quy hoạch khác">
                <RecordsManagement isOtherPlanning />
              </LayoutView>
            )}
            path={UrlCollection.OtherPlanning}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quy hoạch khác">
                <RecordsManagement isOtherPlanning />
              </LayoutView>
            )}
            path={UrlCollection.OtherPlanning}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Thêm dự án quy hoạch khác">
                <AddRecordsManagement isOtherPlanning />
              </LayoutView>
            )}
            path={UrlCollection.AddOtherPlanning}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Chỉnh sửa dự án quy hoạch khác">
                <EditRecordsManagement isOtherPlanning />
              </LayoutView>
            )}
            path={UrlCollection.EditOtherPlanning}
          />

          {/* Slider */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Slider">
                <Slider />
              </LayoutView>
            )}
            path={UrlCollection.Slider}
          />

          {/* News */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Tin tức">
                <News isQHT />
              </LayoutView>
            )}
            path={UrlCollection.News}
          />

          {/* Planning Announcement Process */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quản lý quy hoạch">
                <RecordsManagement isQHT />
              </LayoutView>
            )}
            path={UrlCollection.PlanningAnnouncementProcess}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Thêm đồ án">
                <AddRecordsManagement isQHT />
              </LayoutView>
            )}
            path={UrlCollection.AddPlanningAnnouncementProcess}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Chỉnh sửa đồ án">
                <EditRecordsManagement isQHT />
              </LayoutView>
            )}
            path={UrlCollection.EditPlanningAnnouncementProcess}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Chỉnh sửa công bố">
                <EditAnnouce />
              </LayoutView>
            )}
            path={UrlCollection.EditAnnouce}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Chỉnh sửa công bố hạ tầng kỹ thuật">
                <EditAnnouce isQHHTKT/>
              </LayoutView>
            )}
            path={UrlCollection.QH_HTKT_Edit_Annouce}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quy hoạch liên quan">
                <PlanningRelate isQHT />
              </LayoutView>
            )}
            path={UrlCollection.PlanningRelate}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutDetail title="Quy hoạch liên quan">
                <PlanningRelatedPage />
              </LayoutDetail>
            )}
            path={UrlCollection.PlanningRelateId}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutDetail title="Thiết lập hồ sơ">
                <DocumentSettingsPage />
              </LayoutDetail>
            )}
            path={UrlCollection.DocumentSettingId}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Thiết lập hồ sơ">
                <DocumentSetting isQHT />
              </LayoutView>
            )}
            path={UrlCollection.DocumentSetting}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutDetail title="Xin ý kiến">
                <ConsultTheCommunityPage />
              </LayoutDetail>
            )}
            path={UrlCollection.ConsultTheCommunityId}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Xin ý kiến">
                <ConsultTheCommunity isQHT />
              </LayoutView>
            )}
            path={UrlCollection.ConsultTheCommunity}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Link bản đồ">
                <LinkMapProcess isQHT />
              </LayoutView>
            )}
            path={UrlCollection.LinkMapProcess}
          />

          {/* Map */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Bản đồ">
                <MapData />
              </LayoutView>
            )}
            path={UrlCollection.MapData}
          />
          <RouteComponent
            exact
            layout={LayoutUserView}
            component={InitMapDataView}
            path={UrlCollection.CreateMapData}
          />

          {/* Email Template */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Email Template">
                <EmailTemplate />
              </LayoutView>
            )}
            path={UrlCollection.EmailTemplate}
          />

          {/*Email Generated */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Email Generated">
                <EmailGenerated />
              </LayoutView>
            )}
            path={UrlCollection.EmailGenerated}
          />

          {/* Role Management */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Role Management">
                <RoleManagement />
              </LayoutView>
            )}
            path={UrlCollection.RoleManagement}
          />

          {/* Contact Management */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Liên hệ">
                <ContactManagement />
              </LayoutView>
            )}
            path={UrlCollection.ContactManagement}
          />
          {/* Log */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quản lý log">
                <Log />
              </LayoutView>
            )}
            path={UrlCollection.Log}
          />
          {/* User Management */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quản lý người dùng">
                <UserManagement />
              </LayoutView>
            )}
            path={UrlCollection.UserManagement}
          />

          {/* commune Management */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quản lý xã phường">
                <CommuneManagement />
              </LayoutView>
            )}
            path={UrlCollection.CommuneManagement}
          />

          {/* District Management */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quản lý quận/huyện">
                <DistrictManagement />
              </LayoutView>
            )}
            path={UrlCollection.DistrictManagement}
          />

          {/* Province Management */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quản lý tỉnh">
                <ProviceManagement />
              </LayoutView>
            )}
            component={ProviceManagement}
            path={UrlCollection.ProvinceManagement}
          />

          {/* Link Group Management */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Danh sách nhóm">
                <LinkGroupManagementView />
              </LayoutView>
            )}
            path={UrlCollection.LinkGroup}
          />

          {/* Service Link Management */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Danh sách liên kết">
                <ServiceLinkManagementView />
              </LayoutView>
            )}
            path={UrlCollection.ServiceLink}
          />
          {/* User log */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Nhật ký người dùng">
                <UserLogHistory />
              </LayoutView>
            )}
            path={UrlCollection.UserLogHistory}
          />

          {/* Opinion Form */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title=" Tạo form xin ý kiến">
                <OpinionForm />
              </LayoutView>
            )}
            path={UrlCollection.OpinionForm}
          />

          {/* Land Type */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quản lý loại đất">
                <LandTypeManagement />
              </LayoutView>
            )}
            path={UrlCollection.LandType}
          />

          {/* Investor */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Chủ đầu tư">
                <Investor />
              </LayoutView>
            )}
            path={UrlCollection.Investor}
          />

          {/* ApprovalAgency */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Cơ quan phê duyệt">
                <ApprovalAgency />
              </LayoutView>
            )}
            path={UrlCollection.ApprovalAgency}
          />

          {/* Land Type */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Quản lý chi tiết loại đất">
                <LandTypeDetailManagement />
              </LayoutView>
            )}
            path={UrlCollection.LandTypeDetail}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Đơn vị lập quy hoạch">
                <PlanningUnit />
              </LayoutView>
            )}
            path={UrlCollection.PlanningUnit}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Danh sách cấp phép xây dựng">
                <LisenceFile />
              </LayoutView>
            )}
            path={UrlCollection.LisenceFile}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Bản đồ cấp phép xây dựng ">
                <MapLisenceFile />
              </LayoutView>
            )}
            path={UrlCollection.CPXD}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Thêm mới cấp phép xây dựng">
                <AddLisenceFile />
              </LayoutView>
            )}
            path={UrlCollection.AddLisenceFile}
          />

          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="Danh sách cấp phép xây dựng">
                <LisenceFile />
              </LayoutView>
            )}
            path={UrlCollection.LisenceFile}
          />
          {/* my account */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="">
                <MyAccount />
              </LayoutView>
            )}
            path={UrlCollection.MyAccount}
          />
          {/* Table Layer Structure */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="">
                <TableStructure />
              </LayoutView>
            )}
            path={UrlCollection.TableStructure}
          />
          {/* Access Denied */}
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="">
                <AccessDenied />
              </LayoutView>
            )}
            path={UrlCollection.AccessDenied}
          />
          <RouteComponent
            exact
            layout={() => (
              <LayoutView title="">
                <DocumentManagement />
              </LayoutView>
            )}
            component={DocumentManagement}
            path={UrlCollection.DocumentManagement}
          />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
